export default {
  'PartRow.Button': ({ }, outlet) => {
    outlet({ action: 'update_part' });
  }
}